import { useController, useFormContext } from "react-hook-form";
import BMCountryCodePicker, {
  BMCountryCodePickerProps,
} from "./BMCountryCodePicker";

type Props = Omit<BMCountryCodePickerProps, "value" | "onChange" | "error"> & {
  name: string;
  testID?: string;
};

export default function BMCountryCodePickerRhf({ name, ...rest }: Props) {
  const { control } = useFormContext();
  const {
    field: { value, onChange },
    fieldState: { error },
  } = useController({
    control,
    name,
  });

  return (
    <BMCountryCodePicker
      {...rest}
      value={value}
      onChange={onChange}
      error={error?.message}
    />
  );
}
